import React, { Component } from "react";
import Header from "../layout/Header";
import BannerSimple from "../layout/BannerSimple";
import AboutComponent from "../layout/AboutComponent";
import JobHistory from "../layout/JobHistory";
import Testimonials from "../layout/Testimonials";
import ContactInformation from "../layout/ContactInformation";
import Footer from "../layout/Footer";
import SEO from "../layout/SEO";
import Competences from "../layout/Competences";

export default class About extends Component {

  componentDidMount() {
    window.resetScript();
  }

  render() {
      return (
          <>
              <SEO
                  title="À Propos"
                  description="Découvrez mon parcours, mes compétences et mon expérience en développement web et création de contenu."
                  keywords="à propos, parcours, compétences, expérience, développement web"
              />
              <Header active={ "About" } modeDark={ true } />

              <BannerSimple title = "À Propos" boxElement = { [ { name: "Accueil", link: "/" }, { name: "À Propos", link: "/about" } ] } />

              <AboutComponent />
              <Competences />
              <JobHistory />

              <Testimonials />

              <ContactInformation />

              <Footer />
          </>
      );
    }

}